package com.example.mystybag.core.model

data class CountryItem(
    val id: Int,
    val name: String,
    val dialCode: String,
    val isoAlpha2: String = ""
)

